import {Component, ElementRef, Input} from '@angular/core';
import {kanPartnersService} from "../../../../services/services/partners";
import {Partner} from "../../../../../classes/partner";
import {MatDialog, PageEvent} from "@angular/material";
import {kanPartnerDialog} from "../../../dialogs/partner-dialog/component";
import {kanAuthService} from "../../../../services/services/auth";

@Component({
    selector: 'kan-partners',
    templateUrl: './component.html',
    styleUrls: ['./component.scss'],
    providers: [kanPartnersService]
})
export class kanPartners {

    @Input() selectedTab: number;
    public loading: boolean = false;
    public partners: Partner[];
    public search: string;
    public pageIndex: number = 0;
    public pageSize: number = 20;
    public totalPartners: number = 0;
    public filter: any = {
        where: {
            and: [
                {
                    active: true
                }
            ]
        },
        include: ['type'],
        skip: 0,
        limit: 20
    };
    public timeout: any;

    constructor(private element: ElementRef,
                private dialog: MatDialog,
                private authService: kanAuthService,
                private partnerService: kanPartnersService) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes): void {
        if (changes.selectedTab.currentValue === 2) {
            this.getPartners();
        }
    }

    get role(): string {
        return this.authService.role;
    }

    public newPartnerDialog(event: any) {
        let dialogRef = this.dialog.open(kanPartnerDialog, {
            disableClose: true,
            width: '100%',
            maxWidth: '100%',
            height: '100%',
            maxHeight: '100%'
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result === 'add') {
                this.getPartners();
            }
        });
    }

    public getPartners(): void {

        this.loading = true;
        this.partnerService.countPartners(this.filter.where)
            .then((count) => {
                this.totalPartners = count;
                return this.partnerService.getPartners(this.filter);
            })
            .then((users) => {
                this.partners = users;
                this.loading = false;
                this.element.nativeElement.querySelector('.kan-partners-admin-container').scrollTop = 0;
            })
            .catch((error) => {
                console.log(error);
                this.loading = false;
            });
    }

    public changePage(event: PageEvent) {

        this.pageIndex = event.pageIndex;
        this.pageSize = event.pageSize;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;
        this.getPartners();
    }

    public setFilter() {
        clearTimeout(this.timeout);
        this.loading = true;
        this.pageIndex = 0;
        this.filter.skip = this.pageIndex * this.pageSize;
        this.filter.limit = this.pageSize;

        this.filter.where = {
            and: [
                {
                    active: true,
                }
            ]
        };

        if (this.search.trim()) {
            let fields = ['name', 'contactPerson', 'email', 'city', 'address', 'phone'];
            this.search.trim().split(/\s+/)
                .forEach((s) => {
                    let andBlock = {
                        or: []
                    };
                    s = s.replace(/[aäàá]/g, '[aäàá]')
                        .replace(/[eëéè]/g, '[eëéè]')
                        .replace(/[iïíì]/g, '[iïíì]')
                        .replace(/[oöóò]/g, '[oöóò]')
                        .replace(/[uüúù]/g, '[uüúù]')
                        .replace(/\./g, '\\.');
                    fields.forEach((field) => {
                        let orBlock = {};
                        orBlock[field] = {
                            like: `.*${s}.*`,
                            options: 'i'
                        };
                        andBlock.or.push(orBlock);
                    });
                    this.filter.where.and.push(andBlock);
                });
        }
        this.timeout = setTimeout(() => {
            this.getPartners();
        }, 800);
    }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/partner/partners/component.ts